import { useQuery } from 'react-query';

import getProductsPredictions from '@/common/api/products/getProductsPredictions';
import { ENDPOINT_PREDICTIONS } from '@/common/constants';

/**
 * Get the product prediction with parameters.
 * @param {number} limit max product to display
 * @param {string} source page that call this hook
 * @param {array} products array of object {id: productId, quantity: productQuantity}
 * @param {boolean} enabled to prevent call if products is empty
 * @returns {UseQueryResult<array of products>}
 */
const useProductsPredictions = ({ limit, source, products, enabled }) =>
  useQuery(
    [ENDPOINT_PREDICTIONS, source, products, limit],
    getProductsPredictions,
    { enabled },
  );

export default useProductsPredictions;
